const STORAGE_KEY = "current_i18n";
const FALLBACK = "zh_CN";

function readLang() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v || FALLBACK;
  } catch (e) {
    return FALLBACK;
  }
}

export default {
  namespaced: true,
  state: {
    langs: ["zh_CN"],
    currentLang: readLang(),
  },
  mutations: {
    SET_LANGS(state, langs) {
      state.langs = langs && langs.length ? langs : ["zh_CN"];
    },
    SET_CURRENT_LANG(state, lang) {
      state.currentLang = lang;
      try {
        localStorage.setItem(STORAGE_KEY, lang);
      } catch (e) {
        // localStorage 不可用，忽略
      }
    },
  },
  getters: {
    showLangSelector: (s) => s.langs.length > 1,
  },
};
